import src from "IMAGE";
export default { src, width: 200, height: 50, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAARklEQVR42j3KoRGAQAwAwS+cInCgeBQCCsA/mQSS0MEVwyvEzZzYstSDs+7E/SAiqCqttf4X7k4ZxpVp3ngjMLOe/jAz+QA/kDEhKpwNxgAAAABJRU5ErkJggg=="};
